<template>
  <section class="wire-configuration">
    <h3>电汇收款配置</h3>
    <a-alert message="国内和国际收款信息独立维护。买家查看转账指引后仍为待付款，需客服核实到账后确认收款。" type="info" show-icon />
    <a-tabs :active-key="type" @change="changeType">
      <a-tab-pane key="2" tab="中国境内电汇 · CNY" :disabled="saving" />
      <a-tab-pane key="1" tab="国际电汇 / International Wire Transfer · USD" :disabled="saving" />
    </a-tabs>
    <a-alert v-if="type === '1'" message="国际电汇客户端仅显示英文标题，请用英文填写收款资料和提醒。币种与金额按当前订单展示；汇款附言会附上订单号。" type="info" show-icon style="margin-bottom:16px" />
    <a-spin :spinning="loading">
      <a-alert v-if="savedCurrency && savedCurrency !== form.paymentCurrency" type="warning" show-icon
        :message="`历史配置币种为 ${savedCurrency}，与当前地区不一致。请核对真实银行账户后再保存，不能只更改币种标签。`" style="margin-bottom:16px" />
      <a-form-model :model="form" layout="vertical">
        <a-row :gutter="24">
          
          <a-col :md="12" :xs="24"><a-form-model-item label="启用该地区电汇"><a-switch :checked="form.status === 1" :disabled="saving || !loaded" @change="form.status = $event ? 1 : 0" /></a-form-model-item></a-col>
          <a-col v-for="field in fields" :key="field.key" :md="12" :xs="24">
            <a-form-model-item :label="field.label" :required="form.status === 1 && field.required">
              <a-input v-if="field.key === 'paymentCurrency'" :value="form.paymentCurrency" disabled />
              <a-input v-else-if="field.key === 'currencyAmount'" :value="form.paymentCurrency + ' · 金额按当前订单实际应付金额展示'" disabled />
              <a-select v-else-if="field.options" v-model="form[field.key]" allow-clear :disabled="saving || !loaded">
                <a-select-option v-for="option in field.options" :key="option" :value="option">{{ option }}</a-select-option>
              </a-select>
              <a-textarea v-else-if="field.key === 'kindReminder'" v-model="form[field.key]" :max-length="255" :rows="3" :disabled="saving || !loaded" />
              <a-input v-else v-model="form[field.key]" :max-length="255" :disabled="saving || !loaded" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24"><a-form-model-item :label="type === '1' ? '银行图标 / Bank Icon（可选）' : '银行图标（可选）'"><file-upload :value="form.bankIcon || ''" type="image" :count="1" @change="form.bankIcon = $event" /></a-form-model-item></a-col>
        </a-row>
        <a-button type="primary" v-hasPermi="['user:bank:edit']" :loading="saving" :disabled="!loaded || loading" @click="save">保存{{ form.paymentCurrency }}配置</a-button>
        <span class="wire-hint">银行手续费仅为说明，不会加到订单应付金额中。切换地区前请保存。</span>
      </a-form-model>
    </a-spin>
    <a-divider />
  </section>
</template>
<script>
import { getWireTransfer, saveWireTransfer } from '@/api/dkmall/wire-transfer'
const currency = type => type === '1' ? 'USD' : 'CNY'
export default {
  name: 'WireTransferConfiguration',
  data () {
    return {
      type: '2', loading: false, loaded: false, saving: false, requestId: 0, savedCurrency: '',
      form: { status: 0, paymentCurrency: 'CNY' }

    }
  },
  computed: {
    fields () {
      const primary = this.type === '1' ? [
        { key: 'payeeName', label: '收款人名称 / Beneficiary Name', required: true },
        { key: 'collectionAccount', label: '收款人账号 / Beneficiary Account No.', required: true },
        { key: 'payeesAddress', label: '收款人地址 / Beneficiary Address' },
        { key: 'beneficiaryBank', label: '收款行名称 / Beneficiary Bank Name', required: true },
        { key: 'bankAddress', label: '收款行地址 / Beneficiary Bank Address' },
        { key: 'bankCountryCity', label: '收款行国家 / 城市 / Beneficiary Bank Country / City' },
        { key: 'bankIdentificationCode', label: 'SWIFT / 银行识别码 / SWIFT / BIC Code' },
        { key: 'intermediaryBank', label: '中间行 / 代理行名称 / Intermediary / Correspondent Bank Name' },
        { key: 'intermediaryAccount', label: '中间行账号 / Intermediary Bank Account No.' },
        { key: 'intermediarySwift', label: '中间行 SWIFT/BIC / Intermediary Bank SWIFT/BIC' },
        { key: 'currencyAmount', label: '币种与金额 / Currency & Amount' },
        { key: 'charges', label: '手续费承担方式 / Charges (SHA / OUR / BEN)', options: ['SHA', 'OUR', 'BEN'] },
        { key: 'paymentReference', label: '汇款附言 / 参考号 / Payment Reference / Remittance Info' },
        { key: 'bankCode', label: '本地清算代码 / Local Bank Code' },
        { key: 'remitterInfo', label: '汇款人信息 / Remitter Name & Account' }
      ] : [
        { key: 'payeeName', label: '收款人名称', required: true },
        { key: 'collectionAccount', label: '收款账号', required: true },
        { key: 'beneficiaryBank', label: '开户银行全称', required: true },
        { key: 'cnapsCode', label: '开户行行号（联行号 / CNAPS）' },
        { key: 'bankProvinceCity', label: '开户省 / 开户市' },
        { key: 'paymentCurrency', label: '币种' },
        { key: 'payeesAddress', label: '收款人地址' },
        { key: 'paymentReference', label: '用途 / 汇款附言' },
        { key: 'bankPhone', label: '开户行电话' }
      ]
      return primary.concat([
        { key: 'deliveryTime', label: this.type === '1' ? '到账时效 / Estimated Arrival Time' : '到账时效' },
        { key: 'bankFee', label: this.type === '1' ? '银行手续费说明 / Bank Fee Notes' : '银行手续费说明' },
        { key: 'kindReminder', label: this.type === '1' ? '转账提醒 / Transfer Notes' : '转账提醒' }
      ])
    }
  },
  created () { this.load() },
  methods: {
    changeType (type) { if (!this.saving) { this.type = type; this.load() } },
    load () {
      const requestId = ++this.requestId
      const type = this.type
      this.loading = true; this.loaded = false
      return getWireTransfer(type).then(response => {
        if (requestId !== this.requestId) return
        const data = response.data || {}
        this.savedCurrency = data.paymentCurrency || ''
        this.form = { ...data, status: Number(data.status || 0), paymentCurrency: currency(type) }
        this.loaded = true
      }).catch(() => {}).finally(() => { if (requestId === this.requestId) this.loading = false })
    },
    save () {
      if (!this.loaded || this.loading || this.saving) return
      if (this.form.status === 1 && this.fields.some(f => f.required && !String(this.form[f.key] || '').trim())) {
        this.$message.warning('请先填写收款账号、收款人和收款银行'); return
      }
      const type = this.type
      const data = { ...this.form, paymentCurrency: currency(type) }
      return this.$confirm({
        title: `保存${data.paymentCurrency}电汇收款信息？`,
        content: '请确认已核对真实收款账号、收款人及币种。保存后商城端将使用这套资料。',
        onOk: () => {
          this.saving = true
          return saveWireTransfer(type, data).then(() => {
            this.savedCurrency = data.paymentCurrency
            this.$message.success('该地区电汇收款配置已保存')
          }).finally(() => { this.saving = false })
        }
      })
    }
  }
}
</script>
<style scoped>
.wire-hint { color: #888; margin-left: 16px; }
.wire-configuration /deep/ .ant-form-item-label { white-space: normal; line-height: 22px; padding-bottom: 8px; }
.wire-configuration /deep/ .ant-form-item-label label { white-space: normal; height: auto; overflow-wrap: anywhere; }
</style>
